import loadable from '@loadable/component';

export const YachtingmonthlySiteWrapper = loadable(
  () => import(/* webpackChunkName: "yachtingmonthly-site" */ './YachtingmonthlySiteWrapper'),
);
